import { Box, Button } from "@mui/material";
//import React from "react";
import React, { useState, useEffect } from "react";
import CustomInput from "../../../../helpers/custom-input";
import { CREATE, DESIGNATOR_LIST, MODAL_ACTION } from "../../../../constants/constatnt-variable";
import { Controller, useForm } from "react-hook-form";
import CustomDropDown from "../../../../helpers/dropdown/custom-dropdown";
import { AdditionalLoanContactValidation } from "../../../../constants/validation-rules";

export default function AdditionalLoanContactForm({
  data,
  action = CREATE,
  onSubmit
}) {



  const { control, setValue, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      name: data?.name,
      phone: data?.phone,
      email: data?.email,
      companyName: data?.companyName,
      designator: data?.designator,
      id: data?.id
    }
  })


  const [formatWorkPhone, setFormatWorkPhone] = useState(formatPhoneNumber(data?.phone));
  const [unformatWorkPhone, setUnformatWorkPhone] = useState(data?.phone || '');


  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return '';
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phoneNumber;
  }

  function handleWorkPhoneChange(event) {
    let unformattedValue = event.target.value.replace(/\D/g, '');

    if (unformattedValue.length > 10) {
      unformattedValue = unformattedValue.slice(0, 10);
    }

    setUnformatWorkPhone(unformattedValue);
    setFormatWorkPhone(formatPhoneNumber(unformattedValue));
  }

  function handleWorkPhoneChangeDB() {

    setValue('phone', unformatWorkPhone)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name='name'
        control={control}
        rules={AdditionalLoanContactValidation.name}
        render={({ field }) => (
          <CustomInput
            {...field}
            type={'text'}
            label={'Name'}
            required
            placeholder={'Jhonson'}
            error={errors?.name?.message}
          />

        )}
      />
      <Controller
        name='phone'
        control={control}
        rules={AdditionalLoanContactValidation.phone}
        render={({ field }) => (
          <CustomInput
            {...field}
            type={'text'}
            label={'Mobile number'}
            required
            placeholder={'(956)252-5262'}
            error={errors?.phone?.message}
            value={formatWorkPhone}
            onChange={handleWorkPhoneChange}
            onBlur={handleWorkPhoneChangeDB}
          />

        )}
      />
      <Controller
        name='email'
        control={control}
        rules={AdditionalLoanContactValidation.email}
        render={({ field }) => (
          <CustomInput
            {...field}
            type={'text'}
            label={'Email ID'}
            required
            placeholder={'Johnson@wiscosin.com'}
            error={errors?.email?.message}
          />

        )}
      />
      <Controller
        name='companyName'
        control={control}
        rules={AdditionalLoanContactValidation.companyName}
        render={({ field }) => (
          <CustomInput
            {...field}
            type={'text'}
            label={'Company Name'}
            required
            error={errors?.companyName?.message}
          />

        )}
      />

      <Controller
        name='designator'
        control={control}
        rules={AdditionalLoanContactValidation.designator}
        render={({ field }) => (
          <>
            <CustomDropDown
              {...field}
              field={field}
              label={'Designator'}
              required
              option={DESIGNATOR_LIST}
              error={errors?.designator?.message}
            />
          </>
        )}
      />
      <Box display="flex" justifyContent="flex-end" m={1}>
        <Button type="submit" id={action} variant="contained">
          {MODAL_ACTION[action]}
        </Button>
      </Box>
    </form>
  );
}
